import { ISvgIconProps, } from '@Assets/icons/interface';
import { SvgIcon, } from '@Assets/icons/SvgIcon';

export const ReportIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props} width={26} height={28} viewBox="0 0 26 28">
    <path fillRule="evenodd" clipRule="evenodd" d="M20 2H12V0H10V2H2C0.89543 2 0 2.89543 0 4V18C0 19.1046 0.89543 20 2 20H10V26H6V28H16V26H12V20H20C21.1046 20 22 19.1046 22 18V4C22 2.89543 21.1046 2 20 2ZM20 18H2V4H20V18ZM12 8H10V16H12V8ZM15 12H17V16H15V12ZM7 10H5V16H7V10Z" fill="#516395" strokeWidth={0} />
  </SvgIcon>;
};
